import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Card, Typography, Button } from "antd";
import { useNavigate } from "react-router-dom";

const { Paragraph } = Typography;

const TrainingStatusReport = () => {
  const token = localStorage.getItem("token");
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/TrainingProgressReport/Manager/List`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setReports(response.data);
    } catch (error) {
      console.error("Error fetching reports:", error);
    }
    setLoading(false);
  };

  const toggleExpand = (id) => {
    if (expandedRowKeys.includes(id)) {
      setExpandedRowKeys(expandedRowKeys.filter((key) => key !== id));
    } else {
      setExpandedRowKeys([...expandedRowKeys, id]);
    }
  };

  const columns = [
    {
      title: "Learner Name",
      dataIndex: "learnerName",
      key: "learnerName",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Report",
      dataIndex: "reportText",
      key: "reportText",
      render: (text, record) => {
        const isExpanded = expandedRowKeys.includes(record.id);
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "4px",
            }}
          >
            <Paragraph
              ellipsis={
                !isExpanded
                  ? {
                      rows: 3,
                    }
                  : false
              }
              style={{ width: "400px", marginBottom: "0" }}
            >
              {text}
            </Paragraph>
            <Button type="link" onClick={() => toggleExpand(record.id)} style={{ padding: 0 }}>
              {isExpanded ? "Show less" : "Read more"}
            </Button>
          </div>
        );
      },
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (date) => new Date(date).toLocaleString(),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Button type="primary" onClick={() => navigate(`/report-Detail/${record.id}`)}>
          View Detail
        </Button>
      ),
    },
  ];

  return (
    <Card loading={loading} title="Training Progress Reports" className="card-professional">
      <Table
        columns={columns}
        dataSource={reports}
        rowKey="id"
        pagination={{ pageSize: 5 }}
        bordered
      />
    </Card>
  );
};

export default TrainingStatusReport;
